export default __webpack_public_path__ + "static/media/MaterialIcons-Regular.b40b5808.svg";